import React from "react";

function WebMail() {
    React.useEffect(()=> {

        window.location.href = "https://br770.hostgator.com.br:2096/"
    }, [])
}
export default WebMail;
